import { useContext } from 'react';
import { DataContext } from '../providers';

export const useData = () => {
  const data = useContext(DataContext);

  return data;
};
